import axiosInstance from "../utils/axiosInstance";

export const getEmailLogsApi = async (params) => {
  const response = await axiosInstance.get("/email-log", { params });
  return response;
};

export const getEmailLogByIdApi = async (id) => {
  const response = await axiosInstance.get(`/email-log/${id}`);
  return response;
};

export const getSmtpStatusApi = async () => {
  const response = await axiosInstance.get("/email-log/smtp-status");
  return response;
};

export const sendTestMailApi = async (data) => {
  const response = await axiosInstance.post("/email-log/send-test", data);
  return response;
};

export const deleteEmailLogApi = async (id) => {
  const response = await axiosInstance.delete(`/email-log/${id}`);
  return response;
};
